import { AfterViewInit, Component, inject, Input, output, ViewChild } from '@angular/core';
import { Components } from '../../cockpitComponents';
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { DropListRegistryService } from '../../cockpitDesigner/drop-list-registry.service';
import { CockpitDesignerStore } from "../../cockpitDesigner/cockpitDesigner.service";
import { GridComponent, IColumnData } from '../../cockpitDesigner/cockpitDesigner.models';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-cockpit-designer-component-wrapper',
  templateUrl: 'component-wrapper.component.html',
  styleUrl: 'component-wrapper.component.css',
  imports: [CommonModule, CdkDropList, CdkDrag, MatIconModule, MatButtonModule]
})

export class ComponentWrapper implements AfterViewInit {

  private readonly designerStore = inject(CockpitDesignerStore)
  @ViewChild(CdkDropList) dropList!: CdkDropList;
  @Input() componentsList: GridComponent[] = []
  @Input() cellId!: string;
  @Input() rowId!: string;
  @Input() columnIndex!: number;
  @Input() columnId!: string;
  onOpenSettings = output<GridComponent>();
  hoveredComponent: string | null = null;
  components = Components
  private registry = inject(DropListRegistryService);


  columnData: IColumnData = {
    parentRowId: '',
    components:[]
  }
  newComponentsList: GridComponent[] = []

  drop(event: CdkDragDrop<any>) {
  
    if (event.previousContainer.id === 'sidebar') {

      const item = event.item.data as GridComponent

      this.designerStore.addComponnet(item.name,this.rowId,this.columnId,event.currentIndex)
      this.designerStore.touched.set(true)

    } else {
      const item = event.item.data as GridComponent
      const oldComponentId = this.componentsList[event.previousIndex]?.id

      if (event.previousContainer.id === event.container.id) {
      
        this.designerStore.moveComponentInSameCell(this.rowId,this.columnId,oldComponentId, event.currentIndex )
         this.designerStore.touched.set(true)
      }

      if (event.previousContainer.id !== event.container.id) {
        const previousRowId = event.previousContainer.data.parentRowId;
        const currentrowId = event.previousContainer.data.parentRowId;
        const newRowId = event.container.data.parentRowId
        const previusColId = event.previousContainer.id;
        const currentColId = event.container.id;

        const position = event.currentIndex
        const previousPosition = event.previousIndex

        
        this.designerStore.transferComponentBetweenCells(previousRowId,previusColId,previousPosition,newRowId,currentColId,position, item.id)
         this.designerStore.touched.set(true)
      }
    }
  }

  getConnectedLists() {
    const list = this.registry.getAll();
    return list
  }

  ngAfterViewInit() {
    this.registry.register(this.dropList);
    this.columnData = {
      components: [...this.componentsList],
      parentRowId: this.rowId
    }

    this.newComponentsList = this.newComponentsList = [...this.componentsList];
  }

  openPopup(item: GridComponent) {
    this.onOpenSettings.emit(item)
  }

}